import createAsyncThunkFromFetch from 'src/store/middlewares/createAsyncThunkFromFetch';
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { AsyncEntity } from 'src/global';
import { CompanyBillingRecord } from 'src/features/companyBilling/companyBilling.types';
import { getBillingByCompanyId, GetBillingParams } from 'src/features/companyBilling/companyBilling.api';
import { RootState } from 'src/store';

const name = 'companyBilling';

export const fetchBillingByCompanyId = createAsyncThunkFromFetch<
  CompanyBillingRecord[],
  {
    companyId: string;
    params?: GetBillingParams;
  }
>(`${name}/fetchBillingByCompanyId`, getBillingByCompanyId);

const companyBillingEntityAdapter = createEntityAdapter<AsyncEntity<CompanyBillingRecord>>({
  selectId: record => record.id,
});

export const companyBillingSelectors = companyBillingEntityAdapter.getSelectors<RootState>(
  state => state.companyBilling
);

const initialState: {
  isPending: boolean;
  hasError: boolean;
} = {
  isPending: false,
  hasError: false,
};

const companyBillingSlice = createSlice({
  name,
  initialState: companyBillingEntityAdapter.getInitialState(initialState),
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchBillingByCompanyId.pending, state => {
      state.isPending = true;
      state.hasError = false;
    });
    builder.addCase(fetchBillingByCompanyId.fulfilled, (state, { payload }) => {
      companyBillingEntityAdapter.setAll(state, payload);
    });
    builder.addCase(fetchBillingByCompanyId.rejected, state => {
      state.hasError = true;
    });
  },
});
const { reducer } = companyBillingSlice;

export default reducer;
